const ChatTitle = () =>{
    return (
        <div className="flex items-center justify-center" style={{ height: 48, minHeight: 48 }}>
        Zorintha
        </div>
    );
};

export default ChatTitle;